import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export const RequireAuth = () => {
  const isAuthenticated = useSelector((state: RootState) => !!state.user.jwtToken);
  const location = useLocation();

  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page, saving the
  // location they were trying to go to.
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: location.pathname }} />;
};
